export default __webpack_public_path__ + "static/media/lyve.4ae6a34e.svg";